import React from 'react';
import { useTranslation } from 'react-i18next';
import './UnitPriceCellRenderer.scss';

export const QuantityAvailableCellRenderer: React.FC = (props: any) => {
  const { data } = props;
  // ! for language
  const { t } = useTranslation();

  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'first-row') {
    return null;
  }

  //Handling render box cell in second row for reverse table
  if (data.typeColumn && data.typeColumn === 'second-row') {
    return null;
  }

  let imediateQuantity = 0;
  let marketPlaceQuantity = 0;

  //Count quantity for each vendor
  data?.productVariations?.forEach(function (item: any) {
    if (item.isMarketPlace) {
      marketPlaceQuantity += item.quantityAvailable;
    }
    else {
      imediateQuantity += item.quantityAvailable;
    }
  }
  )

  //Check if exist isMarketplace in packet
  const foundMarketPlace = data?.productVariations?.find((obj: any) => {
    return obj.isMarketPlace;
  });

  //Check if exist NotIsMarketplace(factory or immediate) in packet
  const foundNotMarketPlace = data?.productVariations?.find((obj: any) => {
    return obj.isMarketPlace !== true;
  });

  /*
  With Cross, the logic now is duplicate the part if part is marketplace.
  When data is cross it will be add property isMarketplace(true/false)
  So when data is source, because it's not handled(duplicated), the property data.isMarketplace will be undefined, we will base on it to display for source different with cross.
  */
  if (data.isMarketPlace === undefined) {
    //In this case, we just have Marketplace in packet,  so will only display marketplace quantity
    if (foundMarketPlace !== undefined && foundNotMarketPlace === undefined) {
      return (
        <>
          <div
            className="quantity_available_container container_parent"
          >
            <span className="quantity_value">{marketPlaceQuantity.toLocaleString('en-US')}</span>
            <span className="quantity_available_container_description">
              {t('xref-marketplace')}
            </span>
          </div>
        </>
      );
    }
    // Have both Marketplace and not marketplace in packet, so will display both immediate & marketplace quantity
    if (foundMarketPlace !== undefined && foundNotMarketPlace !== undefined) {
      return (
        <>
          <div
            className="quantity_available_container container_parent"
          >
            <div className="quantity_available_container">
              <span className="quantity_value">{imediateQuantity.toLocaleString('en-US')}</span>
              <span className="quantity_available_container_description">
                {t('xref-quantity-type-immediate')}
              </span>
            </div>
            {data.manufacturerPublicQuantity !== 0 && (
              <div className="quantity_available_container">
                <span className="quantity_value">{data.manufacturerPublicQuantity.toLocaleString('en-US')}</span>
                <span className="quantity_available_container_description">
                  {t('xref-quantity-type-factory')}
                </span>
              </div>
            )}
            <div className="quantity_available_container">
              <span className="quantity_value">{marketPlaceQuantity.toLocaleString('en-US')}</span>
              <span className="quantity_available_container_description">
                {t('xref-marketplace')}
              </span>
            </div>
          </div>
        </>
      );
    }
    else {
      //Don't have Marketplace in packet, so won't display marketplace quantity
      return (
        <>
          <div
            className="quantity_available_container container_parent"
          >
            <div className="quantity_available_container">
              <span className="quantity_value">{imediateQuantity.toLocaleString('en-US')}</span>
              <span className="quantity_available_container_description">
                {t('xref-quantity-type-immediate')}
              </span>
            </div>
            {data.manufacturerPublicQuantity !== 0 && (
              <div className="quantity_available_container">
                <span className="quantity_value" >{data.manufacturerPublicQuantity.toLocaleString('en-US')}</span>
                <span className="quantity_available_container_description">
                  {t('xref-quantity-type-factory')}
                </span>
              </div>
            )}
          </div>
        </>
      );
    }
  }
  //It means cross, keep it display like normal
  else {
    if (data.isMarketPlace) {
      return (
        <div
          className="quantity_available_container container_parent"
        >
          <span className="quantity_value">{data.productVariations[0].quantityAvailable.toLocaleString('en-US')}</span>
          <span className="quantity_available_container_description">
            {t('xref-marketplace')}
          </span>
        </div>
      );
    } else {
      return (
        <>
          <div
            className="quantity_available_container container_parent"
          >
            <div className="quantity_available_container">
              <span className="quantity_value">{data.quantityAvailable.toLocaleString('en-US')}</span>
              <span className="quantity_available_container_description">{t('xref-quantity-type-immediate')}</span>
            </div>
          </div>
          {data.manufacturerPublicQuantity !== 0 && (
            <div className="quantity_available_container">
              <span className="quantity_value">{data.manufacturerPublicQuantity.toLocaleString('en-US')}</span>
              <span className="quantity_available_container_description">
                {t('xref-quantity-type-factory')}
              </span>
            </div>
          )}
        </>
      );
    }
  }
};
